import React from 'react'
import {Form, Dropdown} from 'semantic-ui-react'
import {createAPIClient} from '../../../../../services/api'

const {Field} = Form

class MemberSelection extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      members: [],
      isLoading: false
    }
  }
  loadMemberData () {
    const api = createAPIClient()
    this.setState({isLoading: true})
    api.get('/api/users/teammembers')
      .then(response => {
        const members = response.data.response.items
        this.setState({
          members: members,
          isLoading: false
        })
      })
      .catch(error => {
        this.setState({
          isLoading: false
        })
      })
  }
  componentWillMount () {
    this.loadMemberData()
  }
  onMemberChange (e, {value}) {
    this.props.onFieldChange({target:{name: 'assignee', value: value}})
  }
  render () {
    const selectionValues = this.state.members.map(member => {
      return ({
        key: member.id,
        value: member.id,
        text: member.first_name + ' ' + member.last_name
      })
    })
    selectionValues.unshift({key: undefined, value: null, text: 'No one'})
    const selectionInput = (
      <Field>
        <label>Assignee</label>
        <Dropdown
          placeholder='Select team member'
          fluid selection options={selectionValues}
          onChange={this.onMemberChange.bind(this)}
          defaultValue={this.props.selected}
        />
      </Field>
    )
    return selectionInput
  }
}

export default MemberSelection



// WEBPACK FOOTER //
// ./src/pages/settings/templates/components/memberselection/index.js